import { ComponentType } from "react";
import ServiceComponent from "./ServiceCustomComponent";
import theme from "../../../theme";

export default (Component: ComponentType<any>) => ServiceComponent(Component).create({ customTheme: theme });
